import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-border bg-background py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-75" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-76" data-mp="9t1nv80r8fc2">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-border bg-surface p-8 sm:p-12" data-id="element-77" data-mp="etplwdnehwfs">
          <span className="inline-flex rounded-full bg-primary/10 p-4 text-primary" data-id="element-78" data-mp="sm5iavlsqw7q">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-79" data-mp="xivzxnd91zv9" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-bold tracking-tight text-foreground sm:text-4xl" data-id="element-80" data-mp="12jtfds6vkft2">
            7-Day <span className="text-primary" data-id="element-81" data-mp="17iwmdi6f0w3o">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-82" data-mp="25s71ehi8nd7u">
            Study all 6 volumes and 5 bonuses this week. If the technical depth doesn&apos;t match your professional
            needs,{' '}
            <span className="font-semibold text-foreground" data-id="element-83" data-mp="1vszfv71coc9n">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}